import { render, staticRenderFns } from "./FreqsProducts.vue?vue&type=template&id=74e379e4&"
import script from "./FreqsProducts.vue?vue&type=script&lang=js&"
export * from "./FreqsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports